import { render, staticRenderFns } from "./VeiculoDetalhes.vue?vue&type=template&id=23e517f2"
import script from "./VeiculoDetalhes.vue?vue&type=script&lang=js"
export * from "./VeiculoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports